<template>
    <div class="checkout">
        <!-- Loading Screen -->
        <div v-if="loading" class="loading-screen">
            <img src="@/assets/background/capa-compra-loading.png" alt="Carregando" class="loading-image">
        </div>

        <!-- Payment Screen -->
        <div v-else class="payment-screen">
            <Header @cart-ref="setCartRef" />
            <div class="main-content">
                <div class="checkout-container">
                
                    <h2 class="checkout-title">Finalizar Compra</h2>
                    
                    <button class="btn-back-icon" @click="$router.push('/mycart')">
                        <img src="@/assets/icons/Exit.svg" alt="Voltar">
                    </button>

                    <div class="checkout-content">
                        <div class="payment-section">
                            <h3 class="section-title">Escolha a forma de pagamento</h3>

                            <div class="payment-methods">
                                <!-- Recorrência -->
                                <div 
                                    class="payment-option" 
                                    :class="{ active: selectedPayment === 'recurrence' }"
                                    @click="selectPayment('recurrence')"
                                >
                                    <div class="payment-icon">
                                        <i class="fas fa-sync-alt"></i>
                                    </div>
                                    <div class="payment-info">
                                        <h4>Pagamento com Recorrência</h4>
                                        <p>Faturamento automático mensal</p>
                                    </div>
                                    <div class="payment-check">
                                        <i class="fas fa-check-circle"></i>
                                    </div>
                                </div>
                            </div>

                            <!-- Detalhes do pagamento selecionado -->
                            <div v-if="selectedPayment" class="payment-details">
                                <div v-if="selectedPayment === 'recurrence'" class="card-details">
                                    
                                    <!-- Dados Pessoais -->
                                    <h4>Dados do Titular</h4>
                                    <form class="card-form" @submit.prevent>
                                        <div class="form-group">
                                            <label>Nome Completo</label>
                                            <input 
                                                type="text" 
                                                v-model="customerData.full_name" 
                                                placeholder="Nome completo do titular"
                                            >
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group">
                                                <label>CPF</label>
                                                <input 
                                                    type="text" 
                                                    v-model="customerData.cpf" 
                                                    placeholder="000.000.000-00" 
                                                    maxlength="14"
                                                    @input="formatCpf"
                                                >
                                            </div>
                                            <div class="form-group">
                                                <label>Telefone</label>
                                                <input 
                                                    type="text" 
                                                    v-model="customerData.phone" 
                                                    placeholder="(00) 00000-0000" 
                                                    maxlength="15"
                                                    @input="formatPhone"
                                                >
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label>E-mail</label>
                                            <input 
                                                type="email" 
                                                v-model="customerData.email" 
                                                placeholder="email@exemplo.com"
                                            >
                                        </div>
                                    </form>

                                    <div class="section-separator"></div>

                                    <!-- Dados do Cartão -->
                                    <h4>Dados do Cartão</h4>
                                    <form class="card-form" @submit.prevent>
                                        <div class="form-group">
                                            <label>Número do Cartão</label>
                                            <input 
                                                type="text" 
                                                v-model="cardData.number" 
                                                placeholder="0000 0000 0000 0000" 
                                                maxlength="19"
                                                @input="formatCardNumber"
                                            >
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group">
                                                <label>Validade</label>
                                                <input 
                                                    type="text" 
                                                    v-model="cardData.expiry" 
                                                    placeholder="MM/AA" 
                                                    maxlength="5"
                                                    @input="formatExpiry"
                                                >
                                            </div>
                                            <div class="form-group">
                                                <label>CVV</label>
                                                <input 
                                                    type="text" 
                                                    v-model="cardData.cvv" 
                                                    placeholder="000" 
                                                    maxlength="4"
                                                    @input="formatCvv"
                                                >
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label>Nome no Cartão</label>
                                            <input 
                                                type="text" 
                                                v-model="cardData.holder_name" 
                                                placeholder="Nome como está no cartão"
                                            >
                                        </div>
                                        <div class="form-group">
                                            <label>Ciclo de Faturamento</label>
                                            <select disabled class="glass-input">
                                                <option>Mensal - R$ {{ finalTotalPrice }}</option>
                                            </select>
                                        </div>
                                    </form>

                                    <div class="section-separator"></div>

                                    <!-- Endereço de Cobrança -->
                                    <h4>Endereço de Cobrança</h4>
                                    <form class="card-form" @submit.prevent>
                                        <div class="form-row">
                                            <div class="form-group">
                                                <label>CEP</label>
                                                <input 
                                                    type="text" 
                                                    v-model="billingAddress.zip_code" 
                                                    placeholder="00000-000" 
                                                    maxlength="9"
                                                    @input="formatCep"
                                                    @blur="fetchAddressByCep"
                                                >
                                            </div>
                                            <div class="form-group">
                                                <label>Estado (UF)</label>
                                                <input 
                                                    type="text" 
                                                    v-model="billingAddress.state" 
                                                    placeholder="SP" 
                                                    maxlength="2"
                                                >
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label>Rua / Logradouro</label>
                                            <input 
                                                type="text" 
                                                v-model="billingAddress.street" 
                                                placeholder="Nome da rua"
                                            >
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group">
                                                <label>Número</label>
                                                <input 
                                                    type="text" 
                                                    v-model="billingAddress.number" 
                                                    placeholder="Nº"
                                                >
                                            </div>
                                            <div class="form-group">
                                                <label>Complemento</label>
                                                <input 
                                                    type="text" 
                                                    v-model="billingAddress.complement" 
                                                    placeholder="Apto, Bloco, etc."
                                                >
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group">
                                                <label>Bairro</label>
                                                <input 
                                                    type="text" 
                                                    v-model="billingAddress.neighborhood" 
                                                    placeholder="Bairro"
                                                >
                                            </div>
                                            <div class="form-group">
                                                <label>Cidade</label>
                                                <input 
                                                    type="text" 
                                                    v-model="billingAddress.city" 
                                                    placeholder="Cidade"
                                                >
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            
                        </div>

                        <div class="order-summary-panel">
                            <h3>Resumo da Fatura</h3>
                            
                            <div class="summary-items">
                                <div v-for="item in selectedItems" :key="getItemKey(item)" class="summary-item">
                                    <span class="summary-item-name">{{ item.nome_disciplina }}</span>
                                    <span class="summary-item-price">R$ {{ formatPrice(item.preco) }}</span>
                                </div>
                            </div>
                            
                            <hr class="summary-divider">

                            <div v-if="licenseConfig" class="summary-row">
                                <span>Volume de Licenciamento:</span>
                                <strong>{{ licenseConfig.effectiveAccesses }} {{ licenseConfig.purchase_mode === 'tier' ? '(Lote Fechado)' : '' }}</strong>
                            </div>

                            <div v-if="licenseConfig" class="summary-row">
                                <span>Subtotal Anual:</span>
                                <span>R$ {{ formatPrice(licenseConfig.calculatedSubtotalAnnual) }}</span>
                            </div>

                            <div v-if="licenseConfig && licenseConfig.appliedVolumeDiscount > 0" class="summary-row discount-row">
                                <span>Desconto de Lote Anual ({{ licenseConfig.appliedVolumeDiscount }}%):</span>
                                <span>- R$ {{ formatPrice(licenseConfig.calculatedDiscountAmountAnnual) }}</span>
                            </div>

                            <div v-if="licenseConfig" class="summary-row" style="color: #aaa; font-size: 0.85rem;">
                                <span>Total Líquido Anual:</span>
                                <span>R$ {{ licenseConfig.selectedTotalPriceAnnual }}</span>
                            </div>

                            <hr class="summary-divider">

                            <div class="summary-total">
                                <span>Total Líquido Mensal (12x):</span>
                                <span class="total-price">R$ {{ finalTotalPrice }}</span>
                            </div>

                            <button 
                                class="btn-confirm" 
                                @click="confirmPurchase"
                                :disabled="!selectedPayment || processing"
                            >
                                <span v-if="processing" class="btn-loading">
                                    <i class="fas fa-spinner fa-spin"></i>
                                    Processando...
                                </span>
                                <span v-else>
                                    Autorizar Faturamento
                                </span>
                            </button>

                            <!-- Mensagem de erro -->
                            <div v-if="errorMessage" class="error-message summary-msg">
                                <i class="fas fa-exclamation-triangle"></i>
                                <span>{{ errorMessage }}</span>
                            </div>

                            <!-- Mensagem de sucesso -->
                            <div v-if="successMessage" class="success-message summary-msg">
                                <i class="fas fa-check-circle"></i>
                                <span>{{ successMessage }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../components/Header.vue';
import requestV2 from '@/router/requestV2.js';

export default {
    name: 'Checkout',
    components: {
        Header,
    },
    data() {
        return {
            loading: true,
            selectedPayment: null,
            selectedItems: [],
            cartComponent: null,
            licenseConfig: null,
            processing: false,
            errorMessage: '',
            successMessage: '',

            // Dados do cliente
            customerData: {
                full_name: '',
                cpf: '',
                phone: '',
                email: ''
            },

            // Dados do cartão
            cardData: {
                number: '',
                holder_name: '',
                expiry: '',
                cvv: ''
            },

            // Endereço de cobrança
            billingAddress: {
                street: '',
                number: '',
                complement: '',
                neighborhood: '',
                city: '',
                state: '',
                zip_code: '',
                country: 'BR'
            }
        };
    },
    computed: {
        totalPrice() {
            const total = this.selectedItems.reduce((sum, item) => {
                const price = parseFloat(item.preco) || 0;
                return sum + price;
            }, 0);
            return total.toFixed(2).replace('.', ',');
        },
        finalTotalPrice() {
            if (this.licenseConfig && this.licenseConfig.selectedTotalPrice) {
                return this.licenseConfig.selectedTotalPrice;
            }
            return this.totalPrice;
        },
        /** Valor numérico em reais para enviar ao backend */
        finalTotalNumeric() {
            if (this.licenseConfig && this.licenseConfig.selectedTotalPrice) {
                return parseFloat(this.licenseConfig.selectedTotalPrice.replace(',', '.'));
            }
            const total = this.selectedItems.reduce((sum, item) => {
                return sum + (parseFloat(item.preco) || 0);
            }, 0);
            return total;
        }
    },
    methods: {
        async loadSelectedItems() {
            const selectedKeys = localStorage.getItem('selectedCartItems');
            const savedConfig = localStorage.getItem('cartLicenseConfig');
            
            if (savedConfig) {
                try {
                    this.licenseConfig = JSON.parse(savedConfig);
                } catch (e) {
                    console.error('Erro ao carregar config:', e);
                }
            }
            
            try {
                const response = await requestV2.get('/cart');
                const allItems = response.data;
                
                if (selectedKeys) {
                    try {
                        const keys = JSON.parse(selectedKeys);
                        this.selectedItems = allItems.filter(item => 
                            keys.includes(this.getItemKey(item))
                        );
                    } catch (e) {
                        console.error('Erro ao fazer parse de selectedCartItems:', e);
                        this.selectedItems = allItems;
                    }
                } else {
                    this.selectedItems = allItems;
                }
            } catch (e) {
                console.error('Erro ao carregar itens do carrinho na API:', e);
            }
            
            setTimeout(() => {
                this.loading = false;
            }, 500);
        },

        /** Pré-preenche dados do cliente a partir do store/localStorage */
        prefillCustomerData() {
            const user = this.$store.getters.currentUser;
            if (user) {
                this.customerData.full_name = user.nome_usuario || '';
                this.customerData.email = user.email || '';
            }
        },

        getItemKey(item) {
            if (item.isPacote || item.tipo === 'pacote-completo') {
                return `pacote-${item.codigo_disciplina}`;
            }
            return `${item.codigo_disciplina}-${item.tipo || 'individual'}`;
        },
        formatPrice(preco) {
            if (!preco && preco !== 0) return '0,00';
            return parseFloat(preco).toFixed(2).replace('.', ',');
        },
        selectPayment(method) {
            this.selectedPayment = method;
            this.errorMessage = '';
        },

        // ======== Formatação de inputs ========

        formatCardNumber() {
            let value = this.cardData.number.replace(/\D/g, '');
            value = value.substring(0, 16);
            value = value.replace(/(\d{4})(?=\d)/g, '$1 ');
            this.cardData.number = value;
        },

        formatExpiry() {
            let value = this.cardData.expiry.replace(/\D/g, '');
            value = value.substring(0, 4);
            if (value.length >= 2) {
                value = value.substring(0, 2) + '/' + value.substring(2);
            }
            this.cardData.expiry = value;
        },

        formatCvv() {
            this.cardData.cvv = this.cardData.cvv.replace(/\D/g, '').substring(0, 4);
        },

        formatCpf() {
            let value = this.customerData.cpf.replace(/\D/g, '');
            value = value.substring(0, 11);
            if (value.length > 9) {
                value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/, '$1.$2.$3-$4');
            } else if (value.length > 6) {
                value = value.replace(/(\d{3})(\d{3})(\d{1,3})/, '$1.$2.$3');
            } else if (value.length > 3) {
                value = value.replace(/(\d{3})(\d{1,3})/, '$1.$2');
            }
            this.customerData.cpf = value;
        },

        formatPhone() {
            let value = this.customerData.phone.replace(/\D/g, '');
            value = value.substring(0, 11);
            if (value.length > 6) {
                value = value.replace(/(\d{2})(\d{5})(\d{1,4})/, '($1) $2-$3');
            } else if (value.length > 2) {
                value = value.replace(/(\d{2})(\d{1,5})/, '($1) $2');
            }
            this.customerData.phone = value;
        },

        formatCep() {
            let value = this.billingAddress.zip_code.replace(/\D/g, '');
            value = value.substring(0, 8);
            if (value.length > 5) {
                value = value.replace(/(\d{5})(\d{1,3})/, '$1-$2');
            }
            this.billingAddress.zip_code = value;
        },

        /** Busca endereço pelo CEP via ViaCEP */
        async fetchAddressByCep() {
            const cep = this.billingAddress.zip_code.replace(/\D/g, '');
            if (cep.length !== 8) return;

            try {
                const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
                const data = await response.json();
                if (!data.erro) {
                    this.billingAddress.street = data.logradouro || '';
                    this.billingAddress.neighborhood = data.bairro || '';
                    this.billingAddress.city = data.localidade || '';
                    this.billingAddress.state = data.uf || '';
                }
            } catch (e) {
                console.error('Erro ao buscar CEP:', e);
            }
        },

        // ======== Validação ========

        validateForm() {
            // Dados do cliente
            if (!this.customerData.full_name.trim()) {
                return 'Preencha o nome completo do titular.';
            }
            const cpfDigits = this.customerData.cpf.replace(/\D/g, '');
            if (cpfDigits.length !== 11) {
                return 'Preencha o CPF corretamente (11 dígitos).';
            }
            const phoneDigits = this.customerData.phone.replace(/\D/g, '');
            if (phoneDigits.length < 10) {
                return 'Preencha o telefone corretamente.';
            }
            if (!this.customerData.email.trim() || !this.customerData.email.includes('@')) {
                return 'Preencha um e-mail válido.';
            }

            // Dados do cartão
            const cardDigits = this.cardData.number.replace(/\D/g, '');
            if (cardDigits.length < 13 || cardDigits.length > 16) {
                return 'Preencha o número do cartão corretamente.';
            }
            if (!this.cardData.holder_name.trim()) {
                return 'Preencha o nome no cartão.';
            }
            const expiryParts = this.cardData.expiry.split('/');
            if (expiryParts.length !== 2 || expiryParts[0].length !== 2 || expiryParts[1].length !== 2) {
                return 'Preencha a validade do cartão (MM/AA).';
            }
            const expMonth = parseInt(expiryParts[0]);
            if (expMonth < 1 || expMonth > 12) {
                return 'Mês de validade inválido.';
            }
            if (this.cardData.cvv.length < 3) {
                return 'Preencha o CVV corretamente.';
            }

            // Endereço
            const cepDigits = this.billingAddress.zip_code.replace(/\D/g, '');
            if (cepDigits.length !== 8) {
                return 'Preencha o CEP corretamente.';
            }
            if (!this.billingAddress.street.trim()) {
                return 'Preencha a rua / logradouro.';
            }
            if (!this.billingAddress.number.trim()) {
                return 'Preencha o número do endereço.';
            }
            if (!this.billingAddress.neighborhood.trim()) {
                return 'Preencha o bairro.';
            }
            if (!this.billingAddress.city.trim()) {
                return 'Preencha a cidade.';
            }
            if (!this.billingAddress.state.trim() || this.billingAddress.state.length !== 2) {
                return 'Preencha o estado (UF) corretamente.';
            }

            return null; // Sem erros
        },

        // ======== Submissão ========

        async confirmPurchase() {
            if (!this.selectedPayment) {
                this.errorMessage = 'Selecione uma forma de pagamento.';
                return;
            }

            // Validar formulário
            const validationError = this.validateForm();
            if (validationError) {
                this.errorMessage = validationError;
                return;
            }

            this.errorMessage = '';
            this.successMessage = '';
            this.processing = true;

            // Parsear validade do cartão
            const expiryParts = this.cardData.expiry.split('/');
            const expMonth = parseInt(expiryParts[0]);
            const expYear = parseInt('20' + expiryParts[1]);

            // Montar payload conforme esperado pelo criarAssinatura
            const payload = {
                origem: 'asas',
                customer_full_name: this.customerData.full_name.trim(),
                customer_email: this.customerData.email.trim(),
                customer_identity: this.customerData.cpf.replace(/\D/g, ''),
                customer_phone: this.customerData.phone.replace(/\D/g, ''),
                valor_recorrente: this.finalTotalNumeric,
                quantity: this.selectedItems.length || 1,
                card_data: {
                    number: this.cardData.number.replace(/\s/g, ''),
                    holder_name: this.cardData.holder_name.trim().toUpperCase(),
                    exp_month: expMonth,
                    exp_year: expYear,
                    cvv: this.cardData.cvv
                },
                billing_address: {
                    street: this.billingAddress.street.trim(),
                    number: this.billingAddress.number.trim(),
                    complement: this.billingAddress.complement.trim() || 'N/A',
                    neighborhood: this.billingAddress.neighborhood.trim(),
                    city: this.billingAddress.city.trim(),
                    state: this.billingAddress.state.trim().toUpperCase(),
                    zip_code: this.billingAddress.zip_code.replace(/\D/g, ''),
                    country: 'BR'
                }
            };

            try {
                const partnerId = localStorage.getItem('codigo_parceiro') || 1;
                const checkoutPayload = {
                    ...payload,
                    items: this.selectedItems,
                    licenseConfig: this.licenseConfig,
                    partnerId: partnerId
                };

                const response = await requestV2.post('/subscriptions/checkout', checkoutPayload);
                
                console.log('Resposta da assinatura:', response.data);

                if (response.data && response.data.success) {
                    this.successMessage = 'Assinatura criada com sucesso! Redirecionando...';
                    // Salva o ID da assinatura para referência no localstorage
                    // Obs: O ID pode vir da nova resposta se aplicável. Por enquanto salvamos o que tem.
                    localStorage.setItem('lastSubscriptionId', response.data.id);

                    // Limpa o carrinho e as configurações após a compra
                    localStorage.removeItem('cartItems');
                    localStorage.removeItem('selectedCartItems');
                    localStorage.removeItem('cartLicenseConfig');

                    // Redireciona após 2 segundos
                    setTimeout(() => {
                        this.$router.push('/manage');
                    }, 2000);
                } else {
                    this.errorMessage = 'Resposta inesperada do servidor. Tente novamente.';
                }
            } catch (error) {
                console.error('Erro ao criar assinatura:', error);
                
                if (error.response && error.response.data) {
                    const errData = error.response.data;
                    if (errData.message) {
                        this.errorMessage = errData.message;
                    } else if (errData.errors) {
                        // Pagar.me retorna erros em formato de array
                        const messages = Object.values(errData.errors).flat();
                        this.errorMessage = messages.join('; ');
                    } else {
                        this.errorMessage = 'Erro ao processar pagamento. Verifique os dados e tente novamente.';
                    }
                } else {
                    this.errorMessage = 'Erro de conexão. Verifique sua internet e tente novamente.';
                }
            } finally {
                this.processing = false;
            }
        },

        setCartRef(cartRef) {
            this.cartComponent = cartRef;
        }
    },
    mounted() {
        this.loadSelectedItems();
        this.prefillCustomerData();

        // Simula loading
        setTimeout(() => {
            this.loading = false;
        }, 2000);
    }
};
</script>

<style scoped src="../styles/Checkout.css" />